import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import Toggle from 'react-toggle'
import axios from 'axios'
import ActivitiesController from '../../../common/activitiesController/ActivitiesController'
import Button from '../../../common/CustomComponents/Button.js'

class TripCruiseList extends React.Component {
  state = {
    data: [],
    isEditing: false,
  }

  componentDidMount() {
    this.getData()
  }

  getData = async () => {
    await axios
      .get(Constant.getAPI() + '/trips/get-all-cruises', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            data: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleStatusChange = async (id) => {
    await axios
      .put(
        Constant.getAPI() + `/trips/update-cruise-status/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          this.getData()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  deleteCruise = async (id) => {
    await axios
      .delete(Constant.getAPI() + '/trips/delete-cruise/' + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Deleted !', 'Cruise deleted!', 'success')
          this.getData()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  onEdit = (selectedId, order) => {
    this.setState({ isEditing: true, selectedId, order })
  }

  onChangeSort = (selectedId) => {
    var data = {
      id: selectedId,
      order: this.state.order,
    }

    this.setState({ isEditing: false })

    axios
      .put(Constant.getAPI() + '/trips/update-cruise', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        this.getData()
      })
      .catch(() => { })
  }

  render() {
    const columns = [
      {
        name: 'img_en',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (img) => {
            return (
              <>
                <img
                  src={Constant.getImage() + img}
                  className="img-fluid img-50"
                  alt="img"
                  onError={(event) => {
                    event.currentTarget.src = './assets/images/no_image.png'
                  }}
                />
              </>
            )
          },
        },
      },
      {
        name: 'name_en',
        label: 'Name in English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'name_ar',
        label: 'Name in Arabic',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'order',
        label: 'Order',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (order, tableMeta) => {
            var id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <div className="form-group">
                <div className="form-group">
                  <div className="input-group mb-3">
                    {this.state.isEditing ? (
                      this.state.selectedId === id ? (
                        <input
                          type="text"
                          name="order"
                          className="form-control px-1 form-control-sm"
                          style={{ width: '50px' }}
                          onChange={this.onInputChange}
                          value={this.state.order}
                        />
                      ) : (
                        <div
                          className="form-control"
                          style={{ width: '50px' }}
                        >
                          {order}
                        </div>
                      )
                    ) : (
                      <div
                        className="form-control"
                        style={{ width: '50px' }}
                      >
                        {order}
                      </div>
                    )}{' '}
                    <div className="input-group-append border">
                      {this.state.isEditing ? (
                        this.state.selectedId === id ? (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onChangeSort.bind(this, id)}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-check"></i>
                          </span>
                        ) : (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onEdit.bind(this, id, order, '')}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                          </span>
                        )
                      ) : (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                          onClick={this.onEdit.bind(this, id, order, '')}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (isActive, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <div>
                <Toggle
                  id={id}
                  checked={isActive}
                  value={isActive + ''}
                  onChange={this.handleStatusChange.bind(this, id)}
                />
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Cabins',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (id) => {
            return (
              <Link
                to={`/trip-cabin/${id}`}
                className="m-r-15 text-muted"
                data-toggle="tooltip"
                data-placement="top"
                title=""
                data-original-title="Cruise Trip List"
              >
                <i className="f-22 icofont icofont-eye text-dark"></i>
              </Link>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <>
                <div className="d-flex justify-content-start align-items-center">
                  <Link
                    to={`/trip-cruise/add/` + id}
                    className="m-r-15 text-muted"
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    data-original-title="View Cruise Details "
                  >
                    <i className="f-22 icofont icofont-ui-edit text-dark"></i>
                  </Link>
                  {/* <span
                    onClick={this.deleteCruise.bind(this, id)}
                    className="m-r-15 text-muted"
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    data-original-title="Delete"
                  >
                    <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                  </span> */}
                  <ActivitiesController refId={id}>Activities</ActivitiesController>
                </div>
              </>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      search: false,
      filter: false,
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-start">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Cruise List</h4>
                    </div>
                  </div>
                  <Button
                    className="ml-5"
                    to="/trip-cruise/add"
                    startIcon={<i className="icofont icofont-plus m-r-5"></i>}
                  >
                    Add Cruise
                  </Button>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Cruise List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="dt-responsive table-responsive">
                    <MUIDataTable
                      className="table-responsive"
                      data={this.state.data}
                      columns={columns}
                      options={options}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TripCruiseList
